<script setup>
const staticURLImg = useRuntimeConfig().public.staticURLImg
const lightBox = ref(null)
const nuxtApp = useNuxtApp()

const props = defineProps({
    id: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `${props.handle}-images`,
    () => $fetch(`/api/product/query?id=${props.id}&what=images`),
    {
        transform: (data) => {
            return {
                images: data.product.productImages.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})
</script>

<template>
    <v-row id="productimages" class="mb-4 justify-center rounded">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="12"><app-loader /></v-col>
        <v-col v-else cols="12" md="10">
            <v-row id="productimageslider" justify="center" style="min-height: 440 !important">
                <v-col class="">
                    <v-row dense justify="center" class="my-16">
                        <v-col cols="12" class="mb-4">
                            <app-section-header
                                :id="`media`"
                                :title="`Gallery`"
                                :subtitle="`A picture is worth thousand words. Click an image to open the gallery.`"
                            />
                        </v-col>
                        <v-col class="mb-16">
                            <v-sheet class="d-flex justify-center bg-transparent">
                                <v-slide-group show-arrows prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right">
                                    <v-slide-group-item v-for="(img, n) in data.images" :key="img.id">
                                        <v-card
                                            variant="flat"
                                            class="ma-3 bg-transparent"
                                            width="250"
                                            @click.stop="lightBox.open(n)"
                                        >
                                            <v-img :src="staticURLImg + img.source" :alt="img.alt" contain> </v-img>
                                        </v-card>
                                    </v-slide-group-item>
                                </v-slide-group>
                            </v-sheet>
                        </v-col>
                        <the-lightbox ref="lightBox" :data="data.images" />
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>
.bg-grad-anim-blue-purple {
    background: linear-gradient(300deg, #ae39eb, #3948eb, #ae39eb);
    background-size: 180% 180%;
    animation: gradient-animation 15s ease infinite;
}

@keyframes gradient-animation {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
</style>
